import React, { useContext, useEffect, useState } from "react";
import "../../../Clients/ClientModals/FilterModal.css";
import { UnderContractPanelContext } from "../UnderContractPanelContext";
import closeSvg from "../../../../../assets/closeSvg";
import { AppContext } from "../../../../../AppContext";
import { logActivity } from "../../../../utils";

const ChangeDateModal = () => {
  const {
    changeDateModal,
    setChangeDateModal,
    clientName,
    id,
    agentEmails,
    loanOfficerEmail,
    loanEngineerEmail,
    loanProcessorEmail,
  } = useContext(UnderContractPanelContext);

  const { userName, userType, userEmail, makeKey, userCompany } =
    useContext(AppContext);

  let agentEmailOne = "";
  let agentEmailTwo = "";
  if (agentEmails && agentEmails.includes(",")) {
    const agentEmailArray = agentEmails.split(",");
    agentEmailOne = agentEmailArray[0];
    agentEmailTwo = agentEmailArray[1];
  } else if (agentEmails) {
    agentEmailOne = agentEmails;
  } else {
    //Basically if agent email does not exist, we are assigning it a valid email address so that the LO can still click the buttons and send notifications to the processing team.
    agentEmailOne = userEmail;
  }

  const visible = changeDateModal ? "" : "hidden";
  const agentNoteUrl = `/.netlify/functions/agentNoteUrl`;
  const [comment, setComment] = useState("");
  const [dateType, setDateType] = useState("");
  const [date, setDate] = useState("");

  return (
    <>
      <div className={`Modal-background filter ${visible}`}></div>
      <div
        className={`filter-modal-container ${visible}`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={`filter-modal editNotes`}>
          <form
            className="modal-container"
            onSubmit={(e) => {
              e.stopPropagation();
              e.preventDefault();
              const confirmSend = window.confirm(
                "Change of dates may require an Amend to the Purchase Contract to proceed.\n\nClick OK to acknowledge and notify the Move team of the date change."
              );
              if (confirmSend) {
                fetch(agentNoteUrl, {
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                })
                  .then((response) => response.json())
                  .then((data) => {
                    fetch(data.url, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                      },
                      body: JSON.stringify({
                        apiKey: makeKey,
                        id: id,
                        userType: userType,
                        comment: comment,
                        loanOfficerEmail: loanOfficerEmail,
                        loanEngineerEmail: loanEngineerEmail,
                        loanProcessorEmail: loanProcessorEmail,
                        agentEmailOne: agentEmailOne,
                        agentEmailTwo: agentEmailTwo,
                        userName: userName,
                        clientName: clientName,
                        email: "Date Change",
                        date: date,
                        dateType: dateType,
                        userEmail: userEmail,
                      }),
                    });
                  });
                logActivity({
                  apiKey: makeKey,
                  userEmail: userEmail,
                  userType: userType,
                  action: "Sent Date Change",
                  tab: "Under Contract",
                  userCompany: userCompany,
                });
                setChangeDateModal(false);
                e.target.reset();
              }
            }}
          >
            <div className="spaceBetween">
              <div>
                <b>Change Date</b>
              </div>
              <div
                className="textAlignRight"
                onClick={(e) => {
                  setChangeDateModal(false);
                }}
              >
                {closeSvg}
              </div>
            </div>
            <div>
              Notify the Move team of a change in a date or dealine for{" "}
              {clientName}.
            </div>
            <div className="tenPx"></div>
            <div className="spaceBetween">
              Type:
              <select
                className="modal-select"
                required
                name="Category"
                defaultValue=""
                id="Category"
                onChange={(e) => {
                  setDateType(e.target.options[e.target.selectedIndex].text);
                }}
              >
                <option hidden disabled value="">
                  -- Select --
                </option>
                <option value="appraisalInspection">
                  Appraisal Inspection
                </option>
                <option value="appraisalDeadline">Appraisal Deadline</option>
                <option value="titleDeadline">Title Deadline</option>
                <option value="hoiDeadline">HOI Deadline</option>
                <option value="inspectionResolutionDeadline">
                  Inpsection Resolution Deadline
                </option>
                <option value="loanAvailabilityDeadline">
                  Loan Availability Deadline
                </option>
                <option value="closingDate">Closing Date</option>
                <option value="other">Other (specify below)</option>
              </select>
            </div>
            <div className="tenPx"></div>
            <div className="spaceBetween">
              Date changed to:{" "}
              <input
                required
                className="modal-date"
                type="date"
                onChange={(e) => {
                  setDate(e.target.value);
                }}
              ></input>
            </div>
            <div className="tenPx"></div>
            Explanation for change:
            <textarea
              className="fieldInput"
              required
              maxLength={255}
              type="text"
              onChange={(e) => {
                setComment(e.target.value);
              }}
            ></textarea>
            <div className="tenPx"></div>
            <div className="fivePx"></div>
            <button type="submit" className="button defaultColors">
              Send
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ChangeDateModal;
